import React, { useEffect, useState } from 'react'
import { Translate } from "react-redux-i18n";
import moment from "moment";
import DaySelector from "../DateTimeComponents/DaySelector";
import HourSelector from "../DateTimeComponents/HourSelector";
import { generateHoursList } from "../../utils/utils";

const setStartHours = (hours) => {
    let start_hours = [];
    hours.forEach(hour => {
        start_hours.push({
            hour: hour,
            disabled: false
        })
    });
    return start_hours;
}
//maxInterval is in hours
export default function DateTimeClock({ selected_date = moment(), maxInterval = null, onUpdate }) {
    const [{ startHours, endHours, startDate, endDate, last_date_time }, setClockState] = useState({
        startHours: undefined,
        endHours: undefined,
        startDate: undefined,
        endDate: undefined,
        last_date_time: null
    });

    useEffect(() => {
        updateClockState({
            start_date: selected_date,
            end_date: moment(selected_date).add(30, "minutes")
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected_date]);

    const setStartTime = (e) => {
        const selected_start_hour = e.currentTarget.value;
        updateClockState({
            start_date: selected_start_hour,
            end_date: endDate
        });
    };

    const setEndTime = (e) => {
        const selected_end_hour = e.currentTarget.value;
        updateClockState({
            start_date: startDate,
            end_date: selected_end_hour
        });
    };

    const setEndDate = (end_date) => {
        const currentSelectedEndHour = moment(endDate);
        const endDateAndHour = moment(end_date).hour(currentSelectedEndHour.hour()).minute(currentSelectedEndHour.minute());
        updateClockState({
            start_date: startDate,
            end_date: endDateAndHour
        });
    };

    const updateClockState = ({ start_date, end_date }) => {
        const start_hours = generateHoursList(start_date);
        const available_start_hours = setStartHours(start_hours);

        const lastAllowedDateTime = maxInterval ? moment(start_date).add(maxInterval, 'hours') : null;

        if (moment(end_date).isBefore(start_date) || moment(end_date).isSame(start_date)) {
            end_date = moment(start_date).clone().add(30, "minutes");
        }

        const end_hours = generateHoursList(end_date, undefined, lastAllowedDateTime);
        const available_end_hours = setStartHours(end_hours);

        const lastAvailableHour = available_end_hours[available_end_hours.length - 1].hour;
        if (moment(end_date).isAfter(lastAvailableHour)) {
            end_date = lastAvailableHour;
        }
        const newState = {
            startHours: available_start_hours,
            endHours: available_end_hours,
            startDate: moment(start_date).format("YYYY-MM-DD HH:mm"),
            endDate: moment(end_date).format("YYYY-MM-DD HH:mm"),
            last_date_time: lastAllowedDateTime ? lastAllowedDateTime.format("YYYY-MM-DD HH:mm") : null
        }
        setClockState(newState);

        onUpdate({
            start_date: moment(newState.startDate),
            end_date: moment(newState.endDate)
        })
    }

    return (
        <div className="time-selector-wrapper">
            <div className="selector-item">
                <div className="date-selector">
                    <div className="html-select-wrapper disabled">
                        <div className="select-label">
                            <Translate value="booking.start_date" />
                        </div>
                        <select className="day-selector" defaultValue={startDate}>
                            <option value={startDate}>{moment(startDate).format("D MMMM YYYY")}</option>
                        </select>
                    </div>
                </div>
                <div className="time-selector">
                    <div className="html-select-wrapper">
                        <HourSelector
                            available_hours={startHours}
                            selected_hour={startDate}
                            onChange={setStartTime}
                        />
                    </div>
                </div>
            </div>

            <div className="selector-item">
                <div className="date-selector">
                    <div className="html-select-wrapper">
                        <div className="select-label">
                            <Translate value="booking.end_date" />
                        </div>
                        <DaySelector start_date={startDate} onChange={setEndDate} selected_date={endDate} last_date={last_date_time} />
                    </div>
                </div>
                <div className="time-selector">
                    <div className="html-select-wrapper">
                        <HourSelector
                            selected_hour={endDate}
                            available_hours={endHours}
                            onChange={setEndTime}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

}
